import { PcsEntity } from '@app/pcs/models/pcs-entity';
import { PropertyNameMapper } from '@app/shared/forms/property-mapper';
import {gql} from 'apollo-angular';

export interface Label {
  id: number;
  name?: string;
  description?: string;
}

export const label = gql`
    fragment label on Label {
        id
        name
        description
    }
`;

export const labelPropertyMapper = new PropertyNameMapper({
  name: 'name',
  description: 'description'
}, {entityName: PcsEntity.Label});
